import { Injectable } from '@angular/core';
import {Site} from "../models/site";

@Injectable()
export class NavigationService {

  constructor() { }

  static navigateTo(site: Site) {
    // If it's an iPhone..
    if( (navigator.platform.indexOf("iPhone") != -1)
      || (navigator.platform.indexOf("iPod") != -1)
      || (navigator.platform.indexOf("iPad") != -1))
      window.open("maps://maps.google.com/maps?daddr=" + site.address.lat + "," + site.address.lng + "&amp;ll=");
    else
      window.open("http://maps.google.com/maps?daddr=" + site.address.lat + "," + site.address.lng + "&amp;ll=");
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/navigation-service.ts